// Small pieces shared by the AI Champions page, its admin panel and the
// dashboard's champions highlight.
import { useState } from "react";
import { Calculator, Cpu, HardHat, MapPinned, Megaphone, ShieldCheck, type LucideIcon } from "lucide-react";
import type { CommunityId } from "../../data/championsDirectory";

export const COMMUNITY_ICONS: Record<CommunityId, LucideIcon> = {
  land: MapPinned,
  finance: Calculator,
  construction: HardHat,
  sales: Megaphone,
  tech: Cpu,
  corporate: ShieldCheck,
};

export const initials = (name: string) => {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  return ((parts[0]?.[0] ?? "") + (parts.length > 1 ? parts[parts.length - 1][0] : "")).toUpperCase() || "?";
};

/** A champion's photo, or their initials when there isn't one. */
export function Face({ name, photoUrl, size }: { name: string; photoUrl: string | null; size: number }) {
  const [broken, setBroken] = useState<string | null>(null);
  return photoUrl && broken !== photoUrl ? (
    <img
      className="ch-face"
      src={photoUrl}
      alt=""
      width={size}
      height={size}
      style={{ width: size, height: size }}
      onError={() => setBroken(photoUrl)}
    />
  ) : (
    <span className="ch-face ch-face--initials" style={{ width: size, height: size, fontSize: size * 0.36 }} aria-hidden>
      {initials(name)}
    </span>
  );
}
